import type {EditLeadNoteFormPayload} from "./edit-lead-note.schema";

import {editLeadNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../../../lead-keys";

export function editLeadNoteMutationOptions(leadId: string, noteId: number) {
  return mutationOptions({
    mutationKey: leadMutationKeys.editLeadNote,
    mutationFn: (formPayload: EditLeadNoteFormPayload) => editLeadNote(leadId, noteId, formPayload),
    onSuccess: async (_result, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: leadKeys.detail(leadId)});
    },
  });
}
